module.exports = __webpack_public_path__ + "static/media/stephen_curry5.35f90bf0.png";